import type { ArchizeenTileProps as AriaArchizeenTileProps } from '@archipro-design/aria';
import type { SearchResultItem } from '@modules/search';
import type { TileViewModel } from '../type/util';
import { getEstimateReadTime } from '@modules/articles/util';
import type { User } from '~/server/types';
import { getTileEditableItems } from '~/modules/directory/util/tile-helpers';
import type { EditableItem } from '~/modules/directory/type';
import { getArticleTileThumbnail } from '~/utils';

interface ArchizeenTileProps extends EditableItem {
    ID: number;
    image?: string;
    title: string;
    label: string;
    date: string;
    readTime: string;
    professionalID: number;
    size: AriaArchizeenTileProps['size'];
}

export const mapESArchizeenTileViewModel = (
    article: SearchResultItem,
    size: AriaArchizeenTileProps['size'] = 'medium',
    user?: User,
): TileViewModel<ArchizeenTileProps> => {
    const tileLabel =
        article?.Categories.length > 0
            ? article.Categories.join(', ')
            : (article?.Professional ?? '');
    return {
        tile: {
            ID: article.id,
            image: getArticleTileThumbnail(article, 'portrait'),
            title: article?.Title ?? '',
            label: tileLabel,
            date: article.LiveDate
                ? new Date(
                      parseInt(article.LiveDate) * 1000,
                  ).toLocaleDateString('en-NZ', {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric',
                  })
                : '',

            readTime: `${getEstimateReadTime(
                article.ArticleWordCount ?? 0,
            )} min read`,
            size,
            professionalID: article.ProfessionalID ?? 0,

            // edit item info for hot buttons
            ...getTileEditableItems({
                professional: {
                    ID: article.ProfessionalID || 0,
                    Link: article.ProfessionalLink || '',
                },
                itemType: 'articles',
                itemLink: article.Link || '',
                user: user,
            }),
        },
        link: article.Link ?? '',
    };
};
